import styled from 'styled-components';

export const DivFooter = styled.footer`
  width: 100%;
  height: 232px;
  display: flex;
  align-content: center;
  justify-content: center;
  background-color: #ffffff;
  @media (max-width: 670px) {
    height: 300px;
    min-width: 250px;
  }
`;

export const Container = styled.div`
  margin-top: 32px;
  width: 1060px;
  display: flex;
  flex-direction: column;
  font-family: 'Inter';
  font-size: 20px;
  line-height: 24px;
  padding: 0 16px;
  @media (max-width: 670px) {
    width: 85%;
    min-width: 270px;
    padding: 0;
  }
`;

export const Title = styled.h1`
  font-family: 'Inter';
  font-size: 20px;
  line-height: 24px;
  margin-bottom: 20px;
  margin-top: 30px;
`;

export const ContainerSearch = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 0;
  padding: 0;
  border-bottom: 1px solid #d8d8d8;
  padding-bottom: 24px;
  gap: 24px;
  @media (max-width: 670px) {
    flex-direction: column;
  }
`;

export const Search = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 24px;
  position: relative;
  border-radius: 4px;
  width: 100%;
  max-width: 550px;

  @media (max-width: 670px) {
    width: 100%;
    margin-bottom: 0;
  }

  > div {
    width: 100%;
    > input {
      @media (max-width: 670px) {
        width: 100%;
      }
    }
  }
`;

export const VectorIcon = styled.button`
  position: absolute;
  background: none;
  border: none;
  width: 24px;
  top: 34px;
  right: 10px;
  cursor: pointer;
  &:focus {
    transition: none;
    outline: 2px dotted ${props => props.theme.colors?.primary.main.color};
    border-radius: 3px;
  }
`;

export const ContainerItem = styled.div`
  display: flex;
  gap: 18px;
  align-items: center;
  font-size: 14px;
  font-weight: 400;

  img {
    flex-shrink: 0;
    width: 24px;
    height: 24px;
  }

  &:first-child {
    width: 100%;
  }

  &:last-child {
    > div {
      max-width: 170px;
      display: flex;
      justify-content: space-around;
      white-space: nowrap;
      > a {
        display: flex;
        align-items: center;
        text-decoration: none;
        font-weight: 700;

        > span {
          display: flex;
          margin-right: 7px;
          &:last-child {
            margin-left: 7px;
          }
        }
        &:visited {
          color: ${props => props.theme.colors?.primary.main.color};
        }
        &:focus {
          transition: none;
          outline: 2px dotted ${props => props.theme.colors?.primary.main.color};
          border-radius: 3px;
        }
      }
    }
  }

  @media (max-width: 670px) {
    justify-content: space-between;
    &:last-child {
      width: 100%;
    }
  }

  a {
    color: #005cde;
  }
`;

export const CopyGroup = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 650px) {
    width: 70%;
    flex-direction: column;
    align-self: center;
    text-align: center;
    > a {
      margin-top: 8px;
      margin-bottom: 0;
    }
  }
`;

export const Copy = styled.p`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #666666;
  @media (max-width: 650px) {
    margin-top: 24px;
  }
`;

export const Policy = styled.a`
  margin: 12px 0;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: ${props => props.theme.colors?.primary.main.color};
  cursor: pointer;
  text-decoration: none;
  &:visited {
    color: ${props => props.theme.colors?.primary.main.color};
  }
  &:focus {
    transition: none;
    outline: 2px dotted ${props => props.theme.colors?.primary.main.color};
    border-radius: 3px;
  }
`;

export const WhatsappFloat = styled.div`
  position: fixed;
  right: 8px;
  bottom: 16px;
  width: 80px;
  height: 80px;
  cursor: pointer;

  svg {
    width: 80px;
    height: 80px;
  }

  @media (max-width: 670px) {
    right: 12px;
    bottom: 20px;
    width: 60px;
    height: 60px;

    svg {
      width: 60px;
      height: 60px;
    }
  }
`;
